<template>

  <div class="connect_or_register_modal">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <div class="modal fade" id="connect_or_register_modal" tabindex="-1" aria-labelledby="modal-title"
         aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modal-title">Vous devez être adhérent pour participer.</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form method="post"
                id="membership_request_form"
                @submit.prevent="post_request"
                class="needs-validation" novalidate>
            <div class="modal-body">

            <div class="text-center">
              <a class="btn btn-primary" role="button" href="/connexion">
                Connexion
              </a>
            </div>

            <hr>

            <div class="mt-2 text-center">Ou</div>

            <hr>

            <div class="alert alert-info">
              Vous devez être adhérent pour participer. <br>
              Effectuer votre demande d'adhésion, notre équipe prendra contact avec vous pour finaliser votre adhésion.
            </div>



            <div class="form-group">
              <label for="firstname-input">Prénom</label>
              <input type="text" class="form-control" id="firstname-input" v-model="firstname"
                     required
                     minlength="3"
                     maxlength="64">
              <div class="invalid-feedback">
                Vous devez renseigner votre prénom.
              </div>
            </div>

            <div class="form-group">
              <label for="lastname-input">Nom</label>
              <input type="text" class="form-control" id="lastname-input" v-model="lastname"
                     required
                     minlength="3"
                     maxlength="64">
              <div class="invalid-feedback">
                Vous devez renseigner votre nom.
              </div>


            </div>

            <div class="form-group">
              <label for="email-input">Adresse email</label>
              <input type="email" class="form-control" id="email-input" v-model="email"
                     required
                     minlength="6"
                     maxlength="128">
              <div class="invalid-feedback">
                Vous devez renseigner votre email.
              </div>

            </div>

            <div class="form-group">
              <label for="phone-input">Téléphone</label>
              <input type="phone" class="form-control" id="phone-input" v-model="phone"
                     required
                     minlength="10"
                     maxlength="17">
              <div class="invalid-feedback">
                Vous devez renseigner votre téléphone.
              </div>

            </div>

          </div>
            <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
            <button type="submit" class="btn btn-primary">Valider</button>
          </div>
          </form>
        </div>
      </div>
    </div>


  </div>

</template>

<script>

export default {
  components: {},
  props: [],
  data: function () {
    return {
      firstname: String,
      lastname: String,
      email: String,
      phone: String,
      message: "",
      message_type: "",
    }
  },

  mounted() {
    this.firstname = ''
    this.lastname = ''
    this.email = ''
    this.phone = ''
    this.message = null
    this.message_type = null
  },

  methods: {

    close_message: function () {
      this.message = null;
    },

    post_request: async function () {
      const _this = this

      const form = document.getElementById('membership_request_form');
      if (form.checkValidity() === false) {
        return false
      }

      // if (this.check_input()) {

        let [secure_key, customer_id, api_url] = await get_token_2();
        api_url += "/membership_requests.json"
        api_url += '?secure_key=' + secure_key;
        api_url += '&customer_id=' + customer_id;

        const form_data = new FormData()
        form_data.append('membership_request[firstname]', _this.firstname)
        form_data.append('membership_request[lastname]', _this.lastname)
        form_data.append('membership_request[email]', _this.email)
        form_data.append('membership_request[phone]', _this.phone)

        axios({
          method: 'post',
          url: api_url,
          data: form_data,
          headers: {"cache-control": "no-cache"},
        })
            .then(function (response) {
              const status = response.data.status

              if (status) {
                _this.message = 'Merci, votre demande d\'adhésion est prise en compte. <br> Vous serez bientôt contacté par un membre de l\'équipe';
                _this.message_type = _this.message_type = "alert-success"
                $('#connect_or_register_modal').modal('hide')
              } else {
                _this.message = response.data.error;
                _this.message_type = "alert-danger";
              }

            })
            .catch(function (error) {
              _this.message = error.response.data.error;
              _this.message_type = "alert-danger";
            });
      // }
    },

  },

}

</script>